/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type ListAIIntegrationSchedulesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type ListAIIntegrationSchedulesRequest = {
  /**
   * AI provider identifier. Supported values include cursor, anthropic_compliance, codex_compliance, and chatgpt_compliance.
   */
  provider: string;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListAIIntegrationSchedulesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIIntegrationSchedulesSecurity$outboundSchema: z.ZodMiniType<
  ListAIIntegrationSchedulesSecurity$Outbound,
  ListAIIntegrationSchedulesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listAIIntegrationSchedulesSecurityToJSON(
  listAIIntegrationSchedulesSecurity: ListAIIntegrationSchedulesSecurity,
): string {
  return JSON.stringify(
    ListAIIntegrationSchedulesSecurity$outboundSchema.parse(
      listAIIntegrationSchedulesSecurity,
    ),
  );
}

/** @internal */
export type ListAIIntegrationSchedulesRequest$Outbound = {
  provider: string;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListAIIntegrationSchedulesRequest$outboundSchema: z.ZodMiniType<
  ListAIIntegrationSchedulesRequest$Outbound,
  ListAIIntegrationSchedulesRequest
> = z.pipe(
  z.object({
    provider: z.string(),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listAIIntegrationSchedulesRequestToJSON(
  listAIIntegrationSchedulesRequest: ListAIIntegrationSchedulesRequest,
): string {
  return JSON.stringify(
    ListAIIntegrationSchedulesRequest$outboundSchema.parse(
      listAIIntegrationSchedulesRequest,
    ),
  );
}
